import { createAction } from '@reduxjs/toolkit';
import type { CanvasDimensions, ToolbarType } from './state';

export enum UIActionType {
  RESET_TOOLBAR = 'RESET_TOOLBAR',
  SET_ACTIVE_OBJECT = 'SET_ACTIVE_OBJECT',
  SET_CANVAS_DIMENSIONS = 'SET_CANVAS_DIMENSIONS',
  SET_STEP_PERSONALIZATION = 'SET_STEP_PERSONALIZATION',
  SET_STEP_PREVIEW = 'SET_STEP_PREVIEW',
  SET_TOOLBAR = 'SET_TOOLBAR',
}

export const setPersonalizationStep = createAction(
  UIActionType.SET_STEP_PERSONALIZATION,
);
export const setPreviewStep = createAction(UIActionType.SET_STEP_PREVIEW);
export const setToolbar = createAction<ToolbarType | undefined>(
  UIActionType.SET_TOOLBAR,
);
export const resetToolbar = createAction(UIActionType.RESET_TOOLBAR);
export const setActiveObject = createAction<string | undefined>(
  UIActionType.SET_ACTIVE_OBJECT,
);
export const setCanvasDimensions = createAction<
  Omit<CanvasDimensions, 'valid' | 'scale'>
>(UIActionType.SET_CANVAS_DIMENSIONS);
